export default "__VITE_ASSET__NLVgm5JP__"